import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import _ from 'lodash';
import { Field } from 'react-final-form';
import VoterData from './VoterData';

const VoterIdentificationMethods = ({ voterIdentificationMethods, change, voterIdentificationMethodId, actions, respondent }) => {
  const verificationMethod = voterIdentificationMethods.find(v => v.id === voterIdentificationMethodId);
  const updateIdentificationMethod = (e, id) => {
    change('voterIdentificationMethodId', id);

    const identificationMethod = voterIdentificationMethods.find(i => i.id === id);
    const voter = {};

    if (identificationMethod.voterRequiredData.address) {
      if (!identificationMethod.terytEnabled
        && !identificationMethod.streetsAutocomplete
        && identificationMethod.voterRequiredData.addressRestrictedToCities
        && identificationMethod.voterRequiredData.addressRestrictedToCities.length === 1) {
        voter.city = identificationMethod.voterRequiredData.addressRestrictedToCities[0];
      } else if (!identificationMethod.terytEnabled
        && identificationMethod.streetsAutocomplete
        && identificationMethod.voterRequiredData.addressRestrictedToCities
        && identificationMethod.voterRequiredData.addressRestrictedToCities.length === 1) {
        const data = _.uniqBy(identificationMethod.streetsAutocompleteData, s => s.cityId);
        const city = data.find(c => c.cityName === identificationMethod.voterRequiredData.addressRestrictedToCities[0]);
        if (city) {
          voter.city = city.cityName;
          voter.cityId = city.cityId;
        }
      }
    }

    change('respondent', voter);
    e.preventDefault();
  };

  return (
    <div className="row">
      <div className="box-header-outside">
        <div className="col-sm-12">
          <div className="header">
            <h2>Weryfikacja uczestnika</h2>
          </div>
        </div>
      </div>
      <div className="box">
        <div className="col-sm-12">
          {voterIdentificationMethods.length > 1
            ? <React.Fragment>
                <Typography variant="subtitle2" component="p" gutterBottom>Wybierz metodę weryfikacji danych</Typography>
                <div className="row" style={{ justifyContent: 'center', marginTop: 16, marginBottom: 20 }}>
                  {voterIdentificationMethods.map(method => (
                    <a key={method.id} href="#" onClick={e => updateIdentificationMethod(e, method.id)} className="col-sm-6 col-md-4 obszar-link">
                      <div className="inner-wrapper" style={{ borderWidth: 2, borderStyle: 'solid', borderColor:  voterIdentificationMethodId === method.id ? 'black' : 'transparent'}}>
                        <p>{method.name}</p>
                        <span className="btn">Wybierz</span>
                      </div>
                    </a>
                  ))}
                </div>
            </React.Fragment> : null}
          {verificationMethod ?
              <div>
                <VoterData
                  voterRequiredData={verificationMethod.voterRequiredData || {}}
                  streetsAutocomplete={verificationMethod.streetsAutocomplete}
                  streetsAutocompleteData={verificationMethod.streetsAutocompleteData}
                  terytEnabled={verificationMethod.integrationType === 'radix' || verificationMethod.terytEnabled}
                  terytFilter={verificationMethod.terytFilter}
                  phoneVerificationEnabled={verificationMethod.phoneVerificationEnabled}
                  change={change}
                  actions={actions}
                  values={respondent}
                  verificationMethodId={verificationMethod.id}
                />
              </div>
              : null}
            </div>
        </div>
      
      <Field
        name="voterIdentificationMethodId"
        component={({ meta }) => (meta.error && meta.touched ? <Typography variant="caption" color="error" component="p" style={{ marginTop: 16 }}>{meta.error}</Typography> : null)}
      />
    </div>
  );
};

VoterIdentificationMethods.propTypes = {
  voterIdentificationMethods: PropTypes.array.isRequired,
  change: PropTypes.func.isRequired,
  voterIdentificationMethodId: PropTypes.string,
  respondent: PropTypes.object,
  actions: PropTypes.object.isRequired,
};

export default VoterIdentificationMethods;



// WEBPACK FOOTER //
// ./src/components/consultationSurveys/responderVerification/VoterIdentificationMethods.js